export { default } from "./input"
export type { InputProps } from "./input"
export type { InputColor, InputAlign, InputClearTrigger } from "./input.shared"
